var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrappper"},[_c('div',{staticClass:"row dashboard-container"},[_c('router-view',{attrs:{"account_id":_vm.account_id,"userId":_vm.userId,"roleId":_vm.roleId,"roleInfo":_vm.roleInfo}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }